export default {
  namespaced: true,

  state: {
    incident: null,
    source: {},
    client: {},
    vehicles: {
      client: {},
      thirdParty: {}
    },
    occupants: [],
    has_occupants: true,
    vulnerabilities: [],
    has_vulnerabilities: true,
    details: {},
    thirdParties: [],
    witnesses: [],
    has_witnesses: true,
    policeReports: [],
    journey: {},
    recovery: {},
    repair: {},
    personalInjury: [],
    salvage: {},
    vehicleRecovery: {},
    diminution: {},
    paymentPack: {},
    reasons: [],
    parties: [],
    estimate: {},
    creditHires: [],
    liabilityType: {},
    liabilityStatusId: undefined,
    claimType: {},
    dates: [],
    services: [],
    reason: null,
    handler: undefined,
    author: undefined,
    loading: true
  },

  actions: {
    retrieve(context, id) {
      context.commit('clearRecord');
      context.commit('loading');

      window.Ajax.get(`/incidents/${id}`)
        .then(response => {
          context.dispatch('setIncident', response.data);
          context.commit('loaded');
        })
        .catch(error => {
          window.toastify.error('Sorry, there was a problem loading the claim');
        });
    },

    setIncident(context, incident) {
      context.commit('setIncident', incident);
      context.commit('setHasOccupants', incident.has_occupants);
      context.commit('setOccupants', incident.occupants);
      context.commit(
        'setHasVulnerabilities',
        incident.client.has_vulnerabilities
      );
      context.commit('setVulnerabilities', incident.client.vulnerabilities);
      context.commit('setLiabilityType', incident.liability_type);
      context.commit('setLiabilityStatus', incident.liability_status_id);
      context.commit('setThirdParties', incident.third_parties);
      context.commit('setWitnesses', incident.witnesses);
      context.commit('setPoliceReports', incident.police_reports || []);
      context.commit('setClaimType', incident.claim_type);
      context.commit('setServices', incident.services);
      context.commit('setRepair', incident.repair);
      context.commit('setSalvage', incident.salvage);
      context.commit('setDiminution', incident.diminution);
      context.commit('setVehicleRecovery', incident.vehicle_recovery);
      context.commit('setPersonalInjury', incident.personal_injury || []);
      context.commit('setRejectionReason', incident.reason);
      context.commit('setHandler', incident.handler);
      context.commit('setAuthor', incident.author);
      context.commit('setDates', incident.dates || []);

      if (incident.source) {
        context.commit('setSource', incident.source);
      }

      if (incident.client) {
        context.commit('setClient', incident.client);
        context.commit('setClientVehicle', incident.client.vehicle);
      }

      if (incident.details) {
        context.commit('setDetails', incident.details);
      }

      if (incident.third_parties.length) {
        context.commit('setThirdParties', incident.third_parties);
      }

      if (incident.journey) {
        context.commit('setJourney', incident.journey);
      }

      if (incident.recovery) {
        context.commit('setRecovery', incident.recovery);
      }
    }
  },

  mutations: {
    setIncident(state, incident) {
      state.incident = incident;
    },

    retrieveHires(state, { incident, client }) {
      window.Ajax.get(`/incidents/${incident}/client/${client}/hires`)
        .then(response => {
          state.creditHires = response.data;
        })
        .catch(err => {});
    },

    setSource(state, source) {
      state.source = source;
    },

    setClient(state, client) {
      state.client = client;
    },

    setClientVehicle(state, vehicle) {
      state.vehicles.client = vehicle;
    },

    setClientVehicleLocation(state, location) {
      state.vehicles.client.location = location;
    },

    setClientVehicleRecovery(state, recovery) {
      state.vehicles.client.recovery = recovery;
    },

    setClientInsurance(state, insurance) {
      state.client.insurance = insurance;
    },

    setClientIndemnity(state, indemnity) {
      state.client.indemnity = indemnity;
    },

    setOccupants(state, occupants) {
      state.occupants = occupants;
    },

    setVulnerabilities(state, vulnerabilities) {
      state.vulnerabilities = vulnerabilities;
    },

    setPersonalInjury(state, personalInjury) {
      state.personalInjury = personalInjury;
    },

    setHasOccupants(state, value) {
      state.has_occupants = value;
    },

    setHasVulnerabilities(state, value) {
      state.has_vulnerabilities = value;
    },

    setThirdPartyOccupants(state, thirdPartyOccupants) {
      state.thirdParty.third_party_occupants = thirdPartyOccupants;
    },

    setReasons(state, reasons) {
      state.reasons = reasons;
    },

    removeOccupant(state, identifier) {
      let index = state.occupants.findIndex(item => {
        return identifier === item.identifier;
      });

      state.occupants.splice(index, 1);
    },

    removeVulnerability(state, identifier) {
      let index = state.vulnerabilities.findIndex(item => {
        return identifier === item.identifier;
      });

      state.vulnerabilities.splice(index, 1);
    },

    removePersonalInjury(state, identifier) {
      let index = state.personalInjury.findIndex(item => {
        return identifier === item.identifier;
      });

      state.personalInjury.splice(index, 1);
    },

    removeOccupants(state) {
      state.occupants = [];
    },

    removeVulnerabilities(state) {
      state.vulnerabilities = [];
    },

    updateOccupant(state, occupant) {
      let index = state.occupants.findIndex(item => {
        return occupant.identifier === item.identifier;
      });

      state.occupants[index] = occupant;
    },

    updateVulnerability(state, vulnerability) {
      let index = state.vulnerabilities.findIndex(item => {
        return vulnerability.identifier === item.identifier;
      });

      state.vulnerabilities[index] = vulnerability;
    },

    updatePersonalInjury(state, personalInjury) {
      let index = state.personalInjury.findIndex(item => {
        return personalInjury.identifier === item.identifier;
      });

      state.personalInjury[index] = personalInjury;
    },

    addOccupant(state, occupant) {
      state.occupants.push(occupant);
    },

    addVulnerability(state, vulnerability) {
      state.vulnerabilities.push(vulnerability);
    },

    addPersonalInjury(state, personalInjury) {
      state.personalInjury.push(personalInjury);
    },

    removeThirdPartyOccupants(state) {
      state.thirdParty.third_party_occupants = [];
    },

    addThirdPartyOccupant(state, data) {
      const index = state.thirdParties.findIndex(
        thirdParty => thirdParty.identifier === data.thirdParty.identifier
      );

      if (index > -1) {
        const thirdParty = state.thirdParties[index];

        thirdParty?.third_party_occupants?.push(data.occupant);

        state.thirdParties = [
          ...state.thirdParties.slice(0, index),
          thirdParty,
          ...state.thirdParties.slice(index + 1)
        ];
      }
    },

    updateThirdPartyOccupant(state, data) {
      const index = state.thirdParties.findIndex(
        thirdParty => thirdParty.identifier === data.thirdParty.identifier
      );

      if (index > -1) {
        const occupantIndex = state.thirdParties[
          index
        ].third_party_occupants.findIndex(item => {
          return data.occupant.identifier === item.identifier;
        });

        if (occupantIndex > -1) {
          state.thirdParties = [
            ...state.thirdParties.slice(0, index),
            {
              ...state.thirdParties[index],
              third_party_occupants: [
                ...state.thirdParties[index].third_party_occupants.slice(
                  0,
                  occupantIndex
                ),
                data.occupant,
                ...state.thirdParties[index].third_party_occupants.slice(
                  occupantIndex + 1
                )
              ]
            },
            ...state.thirdParties.slice(index + 1)
          ];
        }
      }
    },

    removeThirdPartyOccupant(state, data) {
      const index = state.thirdParties.findIndex(
        thirdParty => thirdParty.identifier === data.thirdParty.identifier
      );

      if (index > -1) {
        const thirdParty = state.thirdParties[index];
        const occupantIndex = thirdParty.third_party_occupants.findIndex(
          item => {
            return data.occupant.identifier === item.identifier;
          }
        );

        thirdParty?.third_party_occupants?.splice(occupantIndex, 1);

        state.thirdParties = [
          ...state.thirdParties.slice(0, index),
          thirdParty,
          ...state.thirdParties.slice(index + 1)
        ];
      }
    },

    setDetails(state, details) {
      state.details = details;
    },

    setDamageDetails(state, damage) {
      if (!state.vehicles.client) {
        state.vehicles.client = {};
      }

      state.vehicles.client.damage = damage;
    },

    setThirdParties(state, thirdParties) {
      state.thirdParties = thirdParties;
    },

    setThirdParty(state, thirdParty) {
      const index = state.thirdParties.findIndex(
        tp => tp.identifier === thirdParty.identifier
      );

      if (index > -1) {
        state.thirdParties = [
          ...state.thirdParties.slice(0, index),
          thirdParty,
          ...state.thirdParties.slice(index + 1)
        ];
      } else {
        state.thirdParties.push(thirdParty);
      }
    },

    addThirdParty(state, thirdParty) {
      state.thirdParties.push(thirdParty);
    },

    removeThirdParty(state, thirdParty) {
      const index = state.thirdParties.findIndex(
        tp => tp.identifier === thirdParty.identifier
      );

      if (index > -1) {
        state.thirdParties.splice(index, 1);
      }
    },

    setThirdPartyVehicle(state, data) {
      const index = state.thirdParties.findIndex(
        thirdParty => thirdParty.identifier === data.thirdParty.identifier
      );

      if (index > -1) {
        state.thirdParties = [
          ...state.thirdParties.slice(0, index),
          {
            ...state.thirdParties[index],
            vehicle: data.vehicle
          },
          ...state.thirdParties.slice(index + 1)
        ];
      }
    },

    setThirdPartyVehicleDamage(state, data) {
      const index = state.thirdParties.findIndex(
        thirdParty => thirdParty.identifier === data.thirdParty.identifier
      );

      if (index > -1) {
        state.thirdParties = [
          ...state.thirdParties.slice(0, index),
          {
            ...state.thirdParties[index],
            vehicle: {
              ...state.thirdParties[index].vehicle,
              damage: data.damage
            }
          },
          ...state.thirdParties.slice(index + 1)
        ];
      }
    },

    setParties(state, parties) {
      state.parties = parties;
    },

    setWitnesses(state, witnesses) {
      state.witnesses = witnesses;
    },

    setHasWitnesses(state, value) {
      state.has_witnesses = value;
    },

    removeWitness(state, identifier) {
      let index = state.witnesses.findIndex(item => {
        return identifier === item.identifier;
      });

      state.witnesses.splice(index, 1);
    },

    removeWitnesses(state) {
      state.witneses = [];
    },

    updateWitness(state, witness) {
      let index = state.witnesses.findIndex(item => {
        return witness.identifier === item.identifier;
      });

      state.witnesses[index] = witness;
    },

    addWitness(state, witness) {
      state.witnesses.push(witness);
    },

    setPoliceReports(state, reports) {
      state.policeReports = reports;
    },

    removePoliceReport(state, identifier) {
      let index = state.policeReports.findIndex(item => {
        return identifier === item.identifier;
      });

      state.policeReports.splice(index, 1);
    },

    updatePoliceReport(state, policeReport) {
      let index = state.policeReports.findIndex(item => {
        return policeReport.identifier === item.identifier;
      });

      state.policeReports[index] = policeReport;
    },

    addPoliceReport(state, policeReport) {
      state.policeReports.push(policeReport);
    },

    setJourney(state, journey) {
      state.journey = journey;
    },

    setRecovery(state, recovery) {
      state.recovery = recovery;
    },

    setPaymentPack(state, paymentPack) {
      state.paymentPack = paymentPack;
    },

    setEstimate(state, estimate) {
      state.estimate = estimate;
    },

    setCreditHires(state, creditHires) {
      state.creditHires = creditHires;
    },

    setLiabilityType(state, liabilityType) {
      state.liabilityType = liabilityType;
    },

    setLiabilityStatus(state, liabilityStatus) {
      state.liabilityStatusId = liabilityStatus;
    },

    setClaimType(state, claimType) {
      state.claimType = claimType;
    },

    setDates(state, dates) {
      state.dates = dates;
    },

    setRejectionReason(state, reason) {
      state.reason = reason;
    },

    setServices(state, services) {
      state.services = services;
    },

    setRepair(state, repair) {
      state.repair = repair;
    },

    setSalvage(state, salvage) {
      state.salvage = salvage;
    },

    setDiminution(state, diminution) {
      state.diminution = diminution;
    },

    setVehicleRecovery(state, recovery) {
      state.vehicleRecovery = recovery;
    },

    setHandler(state, handler) {
      state.handler = handler;
    },

    setAuthor(state, author) {
      state.author = author;
    },

    loading(state) {
      state.loading = true;
    },

    loaded(state) {
      state.loading = false;
    },

    clearRecord(state) {
      state.incident = null;
      state.source = {};
      state.client = {};
      state.vehicles = {
        client: {},
        thirdParty: {}
      };
      (state.occupants = []), (state.has_occupants = true);
      (state.vulnerabilities = []), (state.has_vulnerabilities = true);
      state.details = {};
      state.thirdParties = [];
      state.witnesses = [];
      state.has_witnesses = true;
      state.policeReports = [];
      state.journey = {};
      state.recovery = {};
      state.paymentPack = {};
      state.reasons = [];
      state.parties = [];
      state.estimate = {};
      state.creditHires = [];
      state.liabilityType = {};
      state.liabilityStatusId = undefined;
      state.claimType = {};
      state.dates = [];
      state.services = [];
      state.repair = [];
      state.salvage = [];
      state.diminution = [];
      state.personalInjury = [];
      state.recovery_service = [];
      state.reason = null;
      state.handler = undefined;
      state.author = undefined;
    }
  },

  getters: {
    incident(state) {
      return state.incident;
    },

    source(state) {
      return state.source;
    },

    client(state) {
      return state.client;
    },

    clientVehicle(state) {
      return state.vehicles.client;
    },

    occupants(state) {
      return state.occupants;
    },

    vulnerabilities(state) {
      return state.vulnerabilities;
    },

    thirdPartyOccupants(state) {
      return state.thirdParties
        .map(thirdParty => thirdParty.third_party_occupants)
        .flat();
    },

    personalInjury(state) {
      return state.personalInjury;
    },

    hasOccupants(state) {
      return state.has_occupants;
    },

    hasVulnerabilities(state) {
      return state.has_vulnerabilities;
    },

    details(state) {
      return state.details;
    },

    damageDetails(state) {
      return state.vehicles?.client?.damage;
    },

    thirdParties(state) {
      return state.thirdParties;
    },

    parties(state) {
      return state.parties;
    },

    witnesses(state) {
      return state.witnesses;
    },

    hasWitnesses(state) {
      return state.has_witnesses;
    },

    policeReports(state) {
      return state.policeReports;
    },

    journey(state) {
      return state.journey;
    },

    recovery(state) {
      return state.recovery;
    },

    paymentPack(state) {
      return state.paymentPack;
    },

    reasons(state) {
      return state.reasons;
    },

    repair(state) {
      return state.repair;
    },

    salvage(state) {
      return state.salvage;
    },

    vehicleRecovery(state) {
      return state.vehicleRecovery;
    },

    diminution(state) {
      return state.diminution;
    },

    estimate(state) {
      return state.estimate;
    },

    creditHires(state) {
      return state.creditHires;
    },

    isFaultClaim(state) {
      if (state.liabilityType?.name === 'full') {
        return true;
      }

      return false;
    },

    isGTA(state) {
      if (state.thirdParties?.length === 1) {
        return state.thirdParties[0].insurer?.gta;
      }

      return false;
    },

    liabilityType(state) {
      return state.liabilityType;
    },

    liabilityStatus(state) {
      return state.liabilityStatusId;
    },

    claimType(state) {
      return state.claimType;
    },

    dates(state) {
      return state.dates;
    },

    rejectionReason(state) {
      return state.reason;
    },

    incidentClaimType(state) {
      return state.source ? state.source.incident_claim_type : null;
    },

    services(state) {
      return state.services;
    },

    handler(state) {
      return state.handler;
    },

    author(state) {
      return state.author;
    },

    loading(state) {
      return state.loading;
    },

    vatRegistered(state) {
      return state.client?.vat_registered || false;
    }
  }
};
